















import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import type { BasicBanner } from '~/components/cms-components/basic-banner/BasicBanner.vue';

type BasicBannerContainer = {
  id: number;
  code: 'basicbanner_container';
  elements: BasicBanner[];
};

export default defineComponent({
  name: 'Container',
  props: {
    data: {
      type: Object as PropType<BasicBannerContainer>,
      default: () => ({})
    },
    aspectRatio: {
      type: String,
      default: '424/159'
    }
  },
  setup(props) {
    const hasBanners = computed(
      () => Array.isArray(props.data.elements) && props.data.elements.length > 0
    );

    const isSlider = computed(() => props.data.elements?.length > 1);

    return { hasBanners, isSlider};
  }
});
